import { SafeHtml } from '@angular/platform-browser';

export class Attendee {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    isOwner: boolean;
    safeMotivation: SafeHtml;
    organizationName: string;
    jobTitle: string;
    profilePicture: string;
}
